import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect map (#592, PARITY.md §5): `…/publish` moved to `…/posts`.
export const Route = createFileRoute("/dashboard/w/$workspaceId/publish")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/posts",
      params: { workspaceId: params.workspaceId },
    });
  },
});
